var icon = require('vue-svgicon')
icon.register({
  'ionicons/ios-minus-empty': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M384 265H128v-17h256v17z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/ionicons/ios-minus-empty.js